
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[hid]/local-area",
      function () {
        return require("private-next-pages/[hid]/local-area/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[hid]/local-area"])
      });
    }
  